import moment from 'moment'
import apiMarim from '../../services/service_undefined_v2'

export default {
  data () {
    return {
      hourSelected: '1',
      nowDate: moment(new Date()),
      hourList: [1, 3, 5, 7, 15, 30],
      description: '',
      defaultValue: moment('00:00:00', 'HH:mm:ss'),
      messageDescription: '',
      result_detail: {
        id: 0,
        title: '',
        start: moment(new Date()).format('DD/MM/YYYY HH:mm:ss'),
        activityDate: '',
        documentDate: '',
        color: 'White',
        status: 0,
        description: '',
        messageDescription: '',
        all_day: false
      }
    }
  },
  methods: {
    moment,
    toggle () {
      $('button[name="hourBtn"]')
        .toggleClass('active')
        .siblings()
        .not(this)
        .removeClass('active')
    },
    removeHowver () {
      // eslint-disable-next-line no-undef
      $('button[name="hourBtn"]')
        .toggleClass('active')
        .siblings()
        .not(this)
        .removeClass('active')
    },
    selectHour ($event) {
      this.nowDate = moment(new Date()).add($event.target.value, 'day')
    },
    selectDateStart (current) {
      // console.log(current)
      return current && current.valueOf() <= moment(new Date()).add(-1, 'day')
    },
    getDetail () {
      this.result_detail = this.$store.state.activity_detail
      this.result_detail.activityDate = moment(this.$store.state.activity_detail.start).format('DD/MM/YYYY HH:mm:ss')
      this.result_detail.documentDate = moment(this.$store.state.activity_detail.create_time).format('DD/MM/YYYY HH:mm:ss')
      this.messageDescription = ''
      this.description = ''
    },
    saveChangeActivity () {
      this.result_detail['description'] = this.description
      this.result_detail['messageDescription'] = this.messageDescription
      this.result_detail['change_date'] = moment(new Date(this.nowDate)).format('YYYY-MM-DD HH:mm:ss')

      this.$store.commit('Loading')
      apiMarim.changeActivity(
        {
          data: this.result_detail
        },
        this.header,
        results => {
          if (results.data.status) {
            this.$store.commit('Loading')
            // eslint-disable-next-line no-undef
            this.$store.state.activity_detail.status = 3
            this.$store.state.activity_detail.start = moment(new Date(this.nowDate)).format('YYYY-MM-DD HH:mm:ss')
            this.$store.state.activity_detail.description = this.description
            this.$store.state.activity_detail.messageDescription = this.messageDescription

            $('#alertPostponse').modal('hide')
            this.$notification['success']({
              message: 'แจ้งเตือน',
              description: 'เลื่อนเวลาการนัดหมายสำเร็จ'
            })
          } else {
            this.$store.commit('Loading')
            this.$notification['warning']({
              message: 'แจ้งเตือน',
              description: 'เลื่อนเวลาการนัดหมายไม่สำเร็จ'
            })
          }
        },
        errors => {
          this.$store.commit('Loading')
          this.$notification['warning']({
            message: 'เลื่อนเวลาการนัดหมายไม่สำเร็จ',
            description: errors.data.message
          })
        }
      )
    }
  },
  mounted () {
    this.nowDate = moment(this.nowDate).add(1, 'days')
    $('#alertPostponse').on(
      'show.bs.modal',
      function () {
        this.getDetail()
      // eslint-disable-next-line no-extra-bind
      }.bind(this)
    )
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/alert_postponse.js